import { AddressFields } from './AddressFields';
import { FormikValues } from 'formik';
import { useAddressForm } from 'hooks/useAddressForm/useAddressForm';
import { LocationDetails } from '@alluradirect/react';
import { useMemo } from 'react';

export function hasAddress(values: any): boolean {
  let hasAnAddress = false;

  if (values?.CITY) {
    hasAnAddress = values?.CITY?.length > 0;
  } else if (values?.STREET_NAME) {
    hasAnAddress = values?.STREET_NAME.length > 0;
  }
  return hasAnAddress;
}

interface Props {
  formikAddressValue: FormikValues;
  formikPrefix?: string;
  locationData: LocationDetails | undefined;
  shouldHideIfNoAddress?: boolean;
  isDisabled?: boolean;
}

const AddressFormikForm = ({
  formikAddressValue,
  formikPrefix = '',
  locationData,
  shouldHideIfNoAddress = true,
  isDisabled = false,
}: Props) => {
  const countries = useMemo(() => {
    return locationData?.COUNTRIES ?? [];
  }, [locationData]);

  const regions = useMemo(() => {
    return locationData?.REGIONS ?? [];
  }, [locationData?.REGIONS]);

  const { filteredRegions, selectedCountry, selectedRegion, handleRegionSelect, handleCountrySelect } = useAddressForm({
    regions,
    countries,
    formikAddressValue: formikAddressValue,
    formikPrefix: formikPrefix,
  });

  const hasAnAddress = useMemo(() => {
    return hasAddress(formikAddressValue);
  }, [formikAddressValue]);

  if (!hasAnAddress && shouldHideIfNoAddress) {
    return null;
  }

  return (
    <AddressFields
      formikPrefix={formikPrefix}
      COUNTRIES={countries}
      selectedCountry={selectedCountry}
      handleCountrySelect={handleCountrySelect}
      filteredRegions={filteredRegions}
      selectedRegion={selectedRegion}
      handleRegionSelect={handleRegionSelect}
      disabled={isDisabled}
    />
  );
};

export default AddressFormikForm;
